import React, { Component } from 'react'
import GoogleMapReact from 'google-map-react'
import { getBirds, addWatchlist, getWatchlist, deleteFromWatchlist } from '../fetch-utils';
import bird_marker from '../bird_marker3.png'
import Watchlist from './Watchlist'

const InfoWindow = (props) => {
    const infoWindowStyle = {
      position: 'relative',
      bottom: 150,
      left: '-45px',
      width: 220,
      backgroundColor: 'white',
      boxShadow: '0 2px 7px 1px rgba(0, 0, 0, 0.3)',
      padding: 10,
      fontSize: 14,
      zIndex: 100,
    };

    return (
      <div style={infoWindowStyle}>
        <div style={{ fontSize: 16 }}>
          <div className="bird-name">
            {props.bird.common_name}
          </div>
          <div className="bird-seen">
            How many seen? {props.bird.number_of_birds}
          </div>
          <div className="bird-date">
            {props.bird.observation_date}
          </div>
          <button onClick={props.onClose}>close</button>
          <button onClick={props.addToWatchlist}>Add to Watch-list</button>
        </div>
      </div>
    );
  };

  const Marker = ({ show, onClose, addToWatchlist, ...bird }) => {
    const markerStyle = {
      height: 10,
      width: 10,
      cursor: 'pointer',
      zIndex: 10,
    };

    return (
      <>
        <div style={markerStyle}>
          <img src={bird_marker} alt="bird" className="bird-marker"/>
        </div>
        {show && <InfoWindow onClose={onClose}bird={bird}addToWatchlist={addToWatchlist} />}
      </>
    );
  };
export default class Map extends Component {

    state = {
        birds: [],
        token: localStorage.getItem('TOKEN'),
        activeMarker: {},
        selectedPlace: {},
        watchlist: []
    }

    static defaultProps = {
        center: {
            lat: 45.509825283405654,
            lng: -122.67084059546936
        },
        zoom: 11
    };

    onMarkerClick = (props, marker, e) =>{
        this.setState({
            selectedPlace: props,
            activeMarker: marker, //this sets state to the clicked marker
          });
    }

    componentDidMount = async () => {
        this.getAllBirds();
        const data = await getWatchlist(this.state.token);
        this.setState({ watchlist: data.body })
    }

    getAllBirds = async () => {
        const response = await getBirds(this.state.token);
        await this.setState({ birds: response.body})

    }
    onClose = () => {
        this.setState({
          activeMarker: {}
        });
    };

    watchListDelete = async (id) => {
      await deleteFromWatchlist(id, this.state.token);
      const data = await getWatchlist(this.state.token);
      this.setState({ watchlist: data.body, activeMarker: {}})
    }
    addToWatchlist = async () => {
      await addWatchlist(this.state.activeMarker, this.state.token);
      const data = await getWatchlist(this.state.token);
      this.setState({ watchlist: data.body, activeMarker: {} })}

    watchListDelete = async (id) => {
      await deleteFromWatchlist(id, this.state.token);
      const data = await getWatchlist(this.state.token);
      this.setState({ watchlist: data.body})
    }

    render() {
        return (
            <div className="app">
                <main className="map">
                    <GoogleMapReact
                    bootstrapURLKeys={{ key: process.env.REACT_APP_MAP_KEY }}
                    defaultCenter={this.props.center}
                    defaultZoom={this.props.zoom}
                    onChildClick={this.onMarkerClick}
                    >
                    {this.state.birds.map((bird, i) =>
                            <Marker
                                key={`${bird.latitude}${bird.longitude}${i}`}
                                lat={bird.latitude}
                                lng={bird.longitude}
                                {...bird}
                                show={bird.subId === this.state.activeMarker.subId} //checking to see if the clicked marker is the same one in the state and if so show it.
                                onClose={this.onClose}
                                addToWatchlist={this.addToWatchlist}
                            />
                        )}
                    </GoogleMapReact>
                </main>
                <div className="watchlist-sidebar">
                    <span className="watchlist-header">
                        "Watch List"
                    </span>
                    <div>
                        <Watchlist onDelete={this.watchListDelete} watchlist={this.state.watchlist} token={this.state.token} />
                    </div>
                </div>
            </div>
        )
    }
}
